import { render, staticRenderFns } from "./ComissoesFesta.vue?vue&type=template&id=72aacbd0&"
import script from "./ComissoesFesta.vue?vue&type=script&lang=js&"
export * from "./ComissoesFesta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports